/* Shared runtime for the static Mivio site import.
   Reimplements the client behaviour of the Next.js components in plain JS. */
(function () {
  var clamp = function (v, lo, hi) { return Math.min(Math.max(v, lo == null ? 0 : lo), hi == null ? 1 : hi); };

  /* ---------- Site header (site-header.tsx) ---------- */
  function initHeader() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var button = header.querySelector(".menu-button");
    var overlay = document.querySelector(".menu-overlay");
    var brand = header.querySelector(".brand");
    var open = false;

    function setOpen(next) {
      open = next;
      document.body.classList.toggle("menu-is-open", open);
      if (overlay) {
        overlay.classList.toggle("menu-overlay--open", open);
        overlay.setAttribute("aria-hidden", String(!open));
      }
      if (button) {
        button.setAttribute("aria-expanded", String(open));
        button.setAttribute("aria-label", open ? "Close navigation menu" : "Open navigation menu");
        var icon = button.querySelector(".about-gk-menu-icon");
        if (icon) icon.classList.toggle("about-gk-menu-icon--open", open);
        else button.textContent = open ? "×" : "≡";
      }
    }
    if (button) button.addEventListener("click", function () { setOpen(!open); });
    if (overlay) {
      overlay.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
      overlay.addEventListener("click", function (e) { if (e.target === overlay) { setOpen(false); if (button) button.focus(); } });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && open) { setOpen(false); if (button) button.focus(); }
    });

    if (document.body.hasAttribute("data-secondary-brand")) document.body.classList.add("secondary-brand-page");

    // Logo swaps to light over dark sections
    if (brand && !header.hasAttribute("data-force-dark-logo")) {
      var frame = 0;
      var update = function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          if (document.body.classList.contains("home-page") && window.matchMedia("(max-width: 760px)").matches) {
            brand.classList.remove("brand--light");
            return;
          }
          var dark = document.querySelectorAll(".moments, footer, [data-header-theme='dark']");
          var y = 48, over = false;
          dark.forEach(function (s) {
            var r = s.getBoundingClientRect();
            if (r.top <= y && r.bottom > y) over = true;
          });
          brand.classList.toggle("brand--light", over);
        });
      };
      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    }
  }

  /* ---------- Reveal + scroll progress (page.tsx) ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
    if (!els.length) return;
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("visible"); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -5% 0px" });
      els.forEach(function (el) { io.observe(el); });
      // Fallback: some embedded contexts throttle IO (and rAF) callbacks ,  reveal synchronously.
      var check = function () {
        els.forEach(function (el) {
          if (el.classList.contains("visible")) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.95 && r.bottom > 0) el.classList.add("visible");
        });
      };
      window.addEventListener("scroll", check, { passive: true });
      window.addEventListener("resize", check);
      check();
      setTimeout(check, 600);
    } else els.forEach(function (el) { el.classList.add("visible"); });
  }

  function initScrollEffects() {
    var progress = document.querySelector(".scroll-progress");
    var intro = document.querySelector(".intro-animation");
    var quote = document.querySelector(".hero-quote");
    if (!progress && !intro && !quote) return;
    var frame = 0;
    var update = function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (progress) progress.style.transform = "scaleX(" + clamp(scrollable > 0 ? window.scrollY / scrollable : 0) + ")";
        if (intro) {
          var p = clamp(-intro.getBoundingClientRect().top / intro.offsetHeight);
          intro.style.setProperty("--intro-scroll", p.toFixed(4));
          intro.style.setProperty("--intro-x", p * 50 + "%");
          intro.style.setProperty("--intro-y", p * -50 + "%");
          intro.style.setProperty("--intro-scale", (1 - p * 0.25).toFixed(4));
        }
        if (quote) {
          var r = quote.getBoundingClientRect();
          var q = clamp((window.innerHeight - r.top) / (window.innerHeight + r.height));
          quote.style.setProperty("--quote-scroll", q.toFixed(4));
          quote.style.setProperty("--quote-x", (-100 + q * 200) + "%");
          quote.style.setProperty("--quote-y", (200 - q * 400) + "%");
          quote.style.setProperty("--quote-special-x", (-15 + q * 30) + "%");
          quote.style.setProperty("--quote-special-y", (50 - q * 100) + "%");
          quote.style.setProperty("--quote-scale", (0.75 + q * 0.25).toFixed(4));
        }
      });
    };
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- ScrollWords (rest-motion.tsx) ---------- */
  function initScrollWords() {
    var section = document.querySelector(".moments");
    if (!section) return;
    var words = Array.prototype.slice.call(section.querySelectorAll("[data-scroll-word]"));
    var frame = 0;
    var update = function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var rect = section.getBoundingClientRect();
        var progress = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height * 0.45));
        words.forEach(function (word, index) {
          var wp = clamp(progress * 1.55 - index / Math.max(words.length, 1));
          word.style.opacity = String(0.18 + wp * 0.82);
        });
      });
    };
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Defer below-fold video downloads ---------- */
  function initLazyVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll("video[data-src]"));
    if (!videos.length) return;
    var load = function (video) {
      if (!video.dataset.src) return;
      video.src = video.dataset.src;
      video.removeAttribute("data-src");
      video.load();
    };
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          load(entry.target);
        });
      }, { rootMargin: "600px 0px", threshold: 0 });
      videos.forEach(function (video) { io.observe(video); });
    } else videos.forEach(load);
  }

  /* ---------- Scroll-controlled product video ---------- */
  function initCoolingSequence() {
    var section = document.querySelector(".cooling-sequence");
    var video = section && section.querySelector("video");
    var canvas = section && section.querySelector(".cooling-sequence__canvas");
    if (!section || !video) return;
    var raf = 0;
    var targetTime = 0;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    var mobilePlayback = window.matchMedia("(max-width: 760px)").matches;
    video.muted = true;

    var drawing = false;
    var drawMobileFrame = function () {
      if (!mobilePlayback || reduce.matches || !canvas || video.readyState < 2 || !video.videoWidth) return;
      var stage = section.querySelector(".cooling-sequence__stage");
      var rect = stage.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      var density = Math.min(window.devicePixelRatio || 1, 2);
      var width = Math.max(1, Math.round(stage.clientWidth * density));
      var height = Math.max(1, Math.round(stage.clientHeight * density));
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
      }
      var context = canvas.getContext("2d", { alpha: false });
      if (!context) return;
      var scale = Math.max(width / video.videoWidth, height / video.videoHeight);
      var sourceWidth = width / scale;
      var sourceHeight = height / scale;
      var sourceX = (video.videoWidth - sourceWidth) / 2;
      var sourceY = (video.videoHeight - sourceHeight) / 2;
      try {
        context.drawImage(video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, width, height);
        section.classList.add("has-mobile-frame");
      } catch (_) {}
    };
    var queueMobileFrame = function () {
      if (!drawing) return;
      drawMobileFrame();
      if (typeof video.requestVideoFrameCallback === "function") video.requestVideoFrameCallback(queueMobileFrame);
      else requestAnimationFrame(queueMobileFrame);
    };
    var beginDrawing = function () {
      if (drawing) return;
      drawing = true;
      queueMobileFrame();
    };
    var startMobileVideo = function () {
      if (!mobilePlayback || reduce.matches) return;
      video.loop = true;
      video.autoplay = true;
      var playback = video.play();
      if (playback && typeof playback.catch === "function") playback.catch(function () {});
    };

    if (mobilePlayback) {
      video.addEventListener("playing", beginDrawing);
      video.addEventListener("pause", function () { drawing = false; });
      video.addEventListener("timeupdate", drawMobileFrame);
      video.addEventListener("error", function () { section.classList.remove("has-mobile-frame"); });
      window.addEventListener("touchstart", function () {
        var rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 2 && rect.bottom > -window.innerHeight) startMobileVideo();
      }, { passive: true });
      if ("IntersectionObserver" in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startMobileVideo();
            else video.pause();
          });
        }, { rootMargin: "100% 0px", threshold: 0 });
        videoObserver.observe(section);
      } else startMobileVideo();
    }

    var fadeWindow = function (p, a, b, c, d) {
      if (p <= a || p >= d) return 0;
      if (p < b) return (p - a) / (b - a);
      if (p <= c) return 1;
      return 1 - (p - c) / (d - c);
    };
    var seek = function () {
      if (mobilePlayback || reduce.matches || video.seeking || video.readyState < 1) return;
      if (Math.abs(video.currentTime - targetTime) > 0.035) video.currentTime = targetTime;
    };
    var update = function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rect = section.getBoundingClientRect();
        var scrollable = Math.max(section.offsetHeight - window.innerHeight, 1);
        var p = clamp(-rect.top / scrollable);
        section.style.setProperty("--sequence-progress", p.toFixed(4));
        section.style.setProperty("--sequence-title", String(clamp(1 - p / 0.19)));
        section.style.setProperty("--sequence-title-shift", clamp(p / 0.22) * 100 + "vw");
        section.style.setProperty("--step-one", String(fadeWindow(p, 0.03, 0.09, 0.23, 0.31)));
        section.style.setProperty("--step-two", String(fadeWindow(p, 0.27, 0.36, 0.51, 0.59)));
        section.style.setProperty("--step-three", String(fadeWindow(p, 0.56, 0.65, 0.83, 0.92)));
        if (Number.isFinite(video.duration)) {
          targetTime = p * Math.max(video.duration - 0.05, 0);
          seek();
        }
        drawMobileFrame();
      });
    };
    video.addEventListener("loadedmetadata", update);
    video.addEventListener("seeked", seek);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Home product gallery + testimonials (page.tsx) ---------- */
  function initHomeGallery() {
    var section = document.querySelector("[data-home-gallery]");
    if (!section) return;
    var stage = section.querySelector(".gallery-image");
    var thumbs = Array.prototype.slice.call(section.querySelectorAll(".gallery-thumbnails button"));
    var counter = section.querySelector(".gallery-controls > span");
    var prev = section.querySelector(".gallery-controls button:first-child");
    var next = section.querySelector(".gallery-controls button:last-child");
    var index = 0;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var pad = function (n) { return String(n).padStart(2, "0"); };
    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      var button = thumbs[index];
      var img = button.querySelector("img");
      var src = button.getAttribute("data-src") || img.getAttribute("src");
      // Fade out, decode the next frame, then apply src and zoom together so
      // the scale change is never visible mid-swap.
      var apply = function () {
        stage.src = src;
        stage.alt = button.getAttribute("data-alt") || "";
        stage.style.setProperty("--hp-zoom", img.style.getPropertyValue("--hp-zoom") || "1");
        stage.toggleAttribute("data-cover", button.hasAttribute("data-cover"));
        stage.classList.remove("is-fading");
      };
      if (reduce) apply();
      else {
        stage.classList.add("is-fading");
        var preload = new Image();
        preload.onload = function () { setTimeout(apply, 60); };
        preload.onerror = apply;
        preload.src = src;
      }
      thumbs.forEach(function (b, bi) {
        b.classList.toggle("active", bi === index);
        b.setAttribute("aria-pressed", String(bi === index));
      });
      if (counter) counter.textContent = pad(index + 1) + " / " + pad(thumbs.length);
      // Keep the active thumbnail in view in the single-row rail.
      if (button.parentElement) {
        var rail = button.parentElement;
        rail.scrollTo({ left: button.offsetLeft - rail.clientWidth / 2 + button.offsetWidth / 2, behavior: "smooth" });
      }
    }
    thumbs.forEach(function (b, bi) { b.addEventListener("click", function () { show(bi); }); });
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
  }

  function initTestimonials() {
    var section = document.querySelector(".testimonials");
    var data = document.getElementById("testimonial-data");
    if (!section || !data) return;
    var items = JSON.parse(data.textContent);
    var image = section.querySelector(".testimonial-image img");
    var imageWrap = section.querySelector(".testimonial-image");
    var quote = section.querySelector("blockquote");
    var author = section.querySelector(".testimonial-author strong");
    var buttons = section.querySelectorAll(".testimonial-controls button");
    var index = 0;
    function replay(el) { el.classList.remove("testimonial-swap"); void el.offsetWidth; el.classList.add("testimonial-swap"); }
    function show(i) {
      index = (i + items.length) % items.length;
      var t = items[index];
      image.src = t.image; image.alt = t.alt;
      quote.textContent = "\u201C" + t.quote + "\u201D";
      author.textContent = t.name + ", " + t.role;
      replay(imageWrap); replay(quote);
    }
    if (buttons[0]) buttons[0].addEventListener("click", function () { show(index - 1); });
    if (buttons[1]) buttons[1].addEventListener("click", function () { show(index + 1); });
  }

  /* ---------- Product detail gallery (product-gallery.tsx) ---------- */
  function initDetailGalleries() {
    document.querySelectorAll(".product-gallery[data-detail-gallery]").forEach(function (root) {
      var stage = root.querySelector(".product-gallery__stage img");
      var buttons = Array.prototype.slice.call(root.querySelectorAll(".product-gallery__thumbnails button"));
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      // Cross-fade rather than swapping the src outright: fade out, decode the
      // next frame, then fade back in so there is no flash of a partial image.
      function show(button) {
        var source = button.querySelector("img");
        var src = source.getAttribute("src");
        var apply = function () {
          stage.src = src;
          stage.alt = button.getAttribute("data-alt") || "";
          stage.style.setProperty("--zoom", source.style.getPropertyValue("--zoom") || "1");
          stage.classList.remove("is-fading");
        };
        if (reduce) { apply(); return; }
        stage.classList.add("is-fading");
        var preload = new Image();
        preload.onload = function () { setTimeout(apply, 60); };
        preload.onerror = apply;
        preload.src = src;
      }

      buttons.forEach(function (b, i) {
        b.addEventListener("click", function () {
          show(b);
          buttons.forEach(function (x, xi) {
            x.classList.toggle("is-selected", xi === i);
            x.setAttribute("aria-pressed", String(xi === i));
          });
        });
      });
    });
  }

  /* ---------- Review carousel (review-carousel.tsx) ---------- */
  function perSlide() {
    if (window.matchMedia("(max-width: 760px)").matches) return 1;
    if (window.matchMedia("(max-width: 1100px)").matches) return 2;
    return 3;
  }
  // Lead with three 5-star reviews, then spread the lower ratings through the rest.
  function orderReviews(list) {
    var five = list.filter(function (r) { return r.rating === 5; });
    var rest = list.filter(function (r) { return r.rating !== 5; });
    var out = five.slice(0, 3);
    var pool = five.slice(3);
    var i = 0, j = 0;
    while (i < pool.length || j < rest.length) {
      if (i < pool.length) out.push(pool[i++]);
      if (i < pool.length) out.push(pool[i++]);
      if (j < rest.length) out.push(rest[j++]);
    }
    return out;
  }
  function initReviewCarousels() {
    var reviews = orderReviews(window.trustpilotReviews || []);
    document.querySelectorAll("[data-review-carousel]").forEach(function (root) {
      var expandable = root.hasAttribute("data-expandable");
      var size = perSlide(), active = 0;
      root.className = "shop-review-carousel";
      root.setAttribute("role", "region");
      root.setAttribute("aria-roledescription", "carousel");
      root.setAttribute("aria-label", "Customer reviews");
      root.tabIndex = 0;

      function initials(name) {
        return name.split(" ").map(function (p) { return p[0]; }).slice(0, 2).join("");
      }
      function stars(rating) {
        var out = "";
        for (var i = 0; i < 5; i++) out += '<span class="' + (i < rating ? "is-filled" : "is-empty") + '" aria-hidden="true">★</span>';
        return out;
      }
      function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }
      function render() {
        var count = Math.ceil(reviews.length / size);
        var start = active * size;
        var visible = reviews.slice(start, start + size);
        var last = Math.min(start + visible.length, reviews.length);
        var dots = "";
        for (var i = 0; i < count; i++) dots += '<i class="' + (i === active ? "is-active" : "") + '"></i>';
        root.innerHTML =
          '<div class="shop-review-carousel__toolbar">' +
            '<div class="shop-review-carousel__brand" role="group" aria-label="Trustpilot reviews"><span aria-hidden="true">★</span><b>Trustpilot</b></div>' +
            '<span aria-live="polite">Reviews ' + (start + 1) + "-" + last + " of " + reviews.length + "</span>" +
          "</div>" +
          '<div class="shop-review-carousel__slide shop-review-carousel__slide--' + size + '" aria-live="polite">' +
          visible.map(function (r, i) {
            return '<article class="shop-review-carousel__card" aria-label="Review ' + (start + i + 1) + " of " + reviews.length + '">' +
              '<div class="shop-review-carousel__identity">' +
                '<span class="shop-review-avatar" aria-hidden="true">' + esc(initials(r.name)) + "</span>" +
                "<div><h3>" + esc(r.name) + "</h3><p>" + esc(r.country) + " · " + r.reviewCount + (r.reviewCount === 1 ? " review" : " reviews") + "</p></div>" +
                '<time datetime="' + esc(r.dateTime) + '">' + esc(r.date) + "</time>" +
              "</div>" +
              '<div class="shop-review-stars shop-review-stars--' + r.rating + '" role="img" aria-label="' + r.rating + ' out of 5 stars">' + stars(r.rating) + "</div>" +
              '<h3 class="shop-review-title">' + esc(r.title) + "</h3>" +
              "<blockquote" + (expandable ? ' class="is-collapsible"' : "") + ">\u201C" + esc(r.body) + "\u201D</blockquote>" +
              (expandable ? '<button class="shop-review-carousel__toggle" type="button" aria-expanded="false">Read full review<span aria-hidden="true">↓</span></button>' : "") +
            "</article>";
          }).join("") +
          "</div>" +
          '<div class="shop-review-carousel__controls">' +
            '<button type="button" data-dir="-1" aria-label="Show previous reviews"><span aria-hidden="true">←</span> Previous</button>' +
            '<div class="shop-review-carousel__dots" aria-hidden="true">' + dots + "</div>" +
            '<button type="button" data-dir="1" aria-label="Show next reviews">Next <span aria-hidden="true">→</span></button>' +
          "</div>";
        root.querySelectorAll("[data-dir]").forEach(function (b) {
          b.addEventListener("click", function () {
            active = (active + Number(b.getAttribute("data-dir")) + count) % count;
            render();
          });
        });
        root.querySelectorAll(".shop-review-carousel__toggle").forEach(function (b) {
          b.addEventListener("click", function () {
            var q = b.previousElementSibling;
            var on = q.classList.toggle("is-expanded");
            b.setAttribute("aria-expanded", String(on));
            b.innerHTML = (on ? "Show less" : "Read full review") + '<span aria-hidden="true">' + (on ? "↑" : "↓") + "</span>";
          });
        });
      }
      root.addEventListener("keydown", function (e) {
        var count = Math.ceil(reviews.length / size);
        if (e.key === "ArrowLeft") { active = (active - 1 + count) % count; render(); }
        if (e.key === "ArrowRight") { active = (active + 1) % count; render(); }
      });
      window.addEventListener("resize", function () {
        var next = perSlide();
        if (next !== size) { size = next; active = 0; render(); }
      });
      render();
    });
  }

  /* ---------- Comfort profile (comfort-profile.tsx) ---------- */
  function initComfortProfile() {
    var root = document.querySelector("[data-comfort-profile]");
    if (!root) return;
    var questions = [
      { prompt: "When does sudden heat disrupt you most?", options: ["During the day", "At work or while travelling", "Overnight", "It varies"] },
      { prompt: "What would make the biggest difference?", options: ["Cooling I can start immediately", "Something discreet and wearable", "Background comfort overnight", "More control wherever I am"] },
      { prompt: "How do you prefer to manage a hot moment?", options: ["A quick cooling session", "A stronger Boost option", "Gentle recurring cooling", "A choice of modes"] },
    ];
    var answers = [];
    root.className = "shop2-profile";
    function result() {
      if (answers.some(function (a) { return a && (a.indexOf("Overnight") >= 0 || a.indexOf("recurring") >= 0); })) return "Night Comfort";
      if (answers.some(function (a) { return a && (a.indexOf("Boost") >= 0 || a.indexOf("immediately") >= 0); })) return "On-Demand Cooling";
      return "Everyday Personal Cooling";
    }
    function render() {
      var answered = questions.filter(function (_, i) { return Boolean(answers[i]); }).length;
      var complete = answered === questions.length;
      root.innerHTML =
        '<div class="shop2-profile__progress" role="progressbar" aria-label="Questions answered" aria-valuemin="0" aria-valuemax="' + questions.length + '" aria-valuenow="' + answered + '">' +
        questions.map(function (_, i) { return '<i class="' + (answers[i] ? "is-complete" : "") + '"></i>'; }).join("") +
        "</div>" +
        questions.map(function (q, qi) {
          return "<fieldset><legend><span>0" + (qi + 1) + "</span>" + q.prompt + "</legend><div>" +
            q.options.map(function (o) {
              var sel = answers[qi] === o;
              return '<button type="button" data-q="' + qi + '" data-o="' + o.replace(/"/g, "&quot;") + '" aria-pressed="' + sel + '" class="' + (sel ? "is-selected" : "") + '">' + o + "</button>";
            }).join("") + "</div></fieldset>";
        }).join("") +
        '<div class="shop2-profile__result ' + (complete ? "is-visible" : "") + '" aria-live="polite">' +
        (complete
          ? "<p>Your comfort profile</p><h3>" + result() + "</h3>" +
            "<span>The Cooling Bracelet gives you Standard, Boost and Night Mode, so you can choose the kind of cooling that suits the moment.</span>" +
            '<a href="/pages/waitlist">JOIN THE WAITLIST <b aria-hidden="true">→</b></a>' +
            "<small>Free to join. No purchase required.</small>"
          : "<p>Choose one answer in each step to see your comfort profile.</p>") +
        "</div>";
      root.querySelectorAll("button[data-q]").forEach(function (b) {
        b.addEventListener("click", function () {
          answers[Number(b.getAttribute("data-q"))] = b.getAttribute("data-o");
          render();
        });
      });
    }
    render();
  }

  /* ---------- Hot-flush stage diagram (shop.html) ----------
     A dot field: columns of dots trace the comfort bounds and the heat-release
     wave, each dropping a hairline stem. Stage parameters ease per frame. The
     pointer cools the field locally; a click sends an expanding pulse. Colour is
     restricted to ink, line, soft-ink and the single gold accent. */
  function initHeatStages() {
    var root = document.getElementById("hf");
    if (!root) return;
    var canvas = root.querySelector(".hf-canvas");
    var context = canvas && canvas.getContext("2d");
    if (!context) return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll(".hf-rail button"));
    var bars = Array.prototype.slice.call(root.querySelectorAll(".hf-progress"));
    var count = root.querySelector(".hf-count");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var css = getComputedStyle(document.body);
    var ink = (css.getPropertyValue("--ink") || "#0a0a0a").trim();
    var soft = (css.getPropertyValue("--soft-ink") || "#333333").trim();
    var line = (css.getPropertyValue("--line") || "#c9c8c2").trim();
    var accent = (css.getPropertyValue("--accent") || "#ba8c53").trim();

    var DURATION = 3200;
    var stage = 1, elapsed = 0, paused = false, started = false, last = 0, raf = 0;
    var w = 0, h = 0, time = 0;
    var pointer = { x: -999, y: -999, on: false };
    var pulses = [];
    // Eased stage parameters: band width, heat amplitude, day travel, ripple, field energy.
    var p = { band: 1, heat: 0, travel: 0, ripple: 0, energy: 0.15 };
    var targets = {
      1: { band: 0.42, heat: 0, travel: 0, ripple: 0, energy: 0.3 },
      2: { band: 0.28, heat: 1, travel: 0, ripple: 1, energy: 1 },
      3: { band: 0.3, heat: 0.94, travel: 1, ripple: 0.5, energy: 0.72 }
    };
    // Geometry shared between draw passes. Narrow fields get tighter gutters
    // and a shorter baseline drop so the curves keep their full amplitude.
    var narrow = w < 760;
    var g = narrow
      ? { padX: 18, padTop: 30, padBottom: 24 }
      : { padX: 40, padTop: 40, padBottom: 34 };

    function hex(value, alpha) {
      var v = value.replace("#", "");
      if (v.length === 3) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
      var n = parseInt(v, 16);
      return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + alpha + ")";
    }
    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var rect = canvas.getBoundingClientRect();
      w = Math.max(rect.width, 1);
      h = Math.max(rect.height, 1);
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      narrow = w < 760;
      g = narrow
        ? { padX: 18, padTop: 30, padBottom: 24 }
        : { padX: 40, padTop: 40, padBottom: 34 };
    }
    function bump(x, centre, sigma) {
      var d = (x - centre) / sigma;
      return Math.exp(-0.5 * d * d);
    }

    function draw() {
      var baseline = h - g.padBottom;
      var top = g.padTop;
      var midY = top + (baseline - top) * 0.56;
      var span = w - g.padX * 2;
      // Fewer, larger dots on a narrow field: 7px columns turn to mush at 320px.
      var columns = Math.max(Math.floor(span / (narrow ? 11 : 7)), 10);
      var bandHalf = (baseline - top) * 0.3 * p.band;
      var amp = (baseline - top) * 0.46 * p.heat;
      var sigma = span * 0.1;
      var crestX = g.padX + span * (0.34 + 0.05 * Math.sin(time * 0.3));
      var wob = 3 + 7 * p.energy;
      var coolReach = span * 0.1;

      function heatAt(x) {
        var s = bump(x, crestX, sigma);
        if (p.travel > 0.02) {
          s += p.travel * (0.64 * bump(x, g.padX + span * 0.672, sigma * 0.5)
            + 0.48 * bump(x, g.padX + span * 0.781, sigma * 0.45)
            + 0.36 * bump(x, g.padX + span * 0.891, sigma * 0.4));
        }
        return Math.min(s, 1.3);
      }
      function coolAt(x) {
        var c = 0;
        if (pointer.on) {
          var d = (x - pointer.x) / coolReach;
          c += Math.exp(-0.5 * d * d) * 0.95;
        }
        for (var i = 0; i < pulses.length; i++) {
          var radius = pulses[i].t * span * 0.95;
          var band = Math.abs(Math.abs(x - pulses[i].x) - radius);
          if (band < 62) c += (1 - band / 62) * (1 - pulses[i].t) * 0.95;
        }
        return Math.min(c, 1);
      }

      context.clearRect(0, 0, w, h);
      context.lineWidth = 1;

      // Axes.
      context.strokeStyle = hex(line, 0.9);
      context.beginPath();
      context.moveTo(g.padX, top - 8);
      context.lineTo(g.padX, baseline);
      context.lineTo(w - g.padX, baseline);
      context.stroke();

      // Hour ticks (stage 03).
      if (p.travel > 0.02) {
        context.strokeStyle = hex(line, 0.95 * p.travel);
        [0.672, 0.781, 0.891].forEach(function (fraction) {
          var x = g.padX + span * fraction;
          context.beginPath();
          context.moveTo(x, baseline);
          context.lineTo(x, baseline - 14);
          context.stroke();
        });
      }

      for (var i = 0; i <= columns; i++) {
        var x = g.padX + (span / columns) * i;
        var strength = heatAt(x);
        var cool = coolAt(x);
        var effective = strength * (1 - cool * 0.88);
        var phase = x * 0.011;

        // Comfort bounds: pushed outward wherever the heat response builds.
        var push = effective * amp * 0.32;
        for (var s = -1; s <= 1; s += 2) {
          var y = midY + s * (bandHalf + push) + Math.sin(phase + time * (0.4 + 0.5 * p.energy) * s) * wob;
          context.strokeStyle = hex(line, 0.3);
          context.beginPath();
          context.moveTo(x, y);
          context.lineTo(x, baseline);
          context.stroke();
          context.fillStyle = hex(ink, 0.26 + 0.2 * Math.min(effective, 1));
          context.beginPath();
          context.arc(x, y, 1.5 + 0.9 * Math.min(effective, 1), 0, Math.PI * 2);
          context.fill();
        }

        // Heat release: the one gold curve. Cooled columns drop to soft ink.
        if (p.heat > 0.02) {
          var hy = midY + bandHalf * 0.78 - amp * effective;
          var cooled = cool > 0.45;
          context.strokeStyle = hex(cooled ? soft : accent, (cooled ? 0.1 : 0.18) * p.heat);
          context.beginPath();
          context.moveTo(x, hy);
          context.lineTo(x, baseline);
          context.stroke();
          context.fillStyle = hex(cooled ? soft : accent, (0.42 + 0.58 * Math.min(effective, 1)) * p.heat);
          context.beginPath();
          context.arc(x, hy, 1.6 + 2.1 * Math.min(effective, 1), 0, Math.PI * 2);
          context.fill();
        }
      }

      var crestY = midY + bandHalf * 0.78 - amp * heatAt(crestX) * (1 - coolAt(crestX) * 0.88);

      // Release rings and rising marks at the crest.
      if (p.ripple > 0.02) {
        for (var r = 0; r < 3; r++) {
          var t = ((time * 0.4) + r * 0.34) % 1;
          context.strokeStyle = hex(accent, (1 - t) * 0.45 * p.ripple);
          context.lineWidth = 1.5;
          context.beginPath();
          context.arc(crestX, crestY, 9 + t * 46, 0, Math.PI * 2);
          context.stroke();
        }
        context.lineWidth = 1;
        for (var k = 0; k < 3; k++) {
          var rise = ((time * 46 + k * 34) % 100);
          context.strokeStyle = hex(accent, (1 - rise / 100) * 0.4 * p.ripple);
          context.beginPath();
          context.moveTo(crestX - 16 + k * 16, crestY - 18 - rise);
          context.lineTo(crestX - 16 + k * 16, crestY - 26 - rise);
          context.stroke();
        }
      }

      // Click pulses.
      for (var q = 0; q < pulses.length; q++) {
        context.strokeStyle = hex(accent, (1 - pulses[q].t) * 0.5);
        context.lineWidth = 1.5;
        context.beginPath();
        context.arc(pulses[q].x, pulses[q].y, pulses[q].t * span * 0.95, 0, Math.PI * 2);
        context.stroke();
      }
      context.lineWidth = 1;

      // Pointer reach indicator.
      if (pointer.on) {
        context.strokeStyle = hex(soft, 0.3);
        context.beginPath();
        context.arc(pointer.x, pointer.y, 44, 0, Math.PI * 2);
        context.stroke();
        context.fillStyle = hex(soft, 0.55);
        context.beginPath();
        context.arc(pointer.x, pointer.y, 2.5, 0, Math.PI * 2);
        context.fill();
      }
    }

    function setBars(progress) {
      bars.forEach(function (bar, i) {
        bar.style.width = (i + 1 === stage ? (progress * 100).toFixed(2) : "0") + "%";
      });
    }
    function show(n) {
      stage = ((n - 1 + 3) % 3) + 1;
      elapsed = 0;
      root.setAttribute("data-stage", String(stage));
      buttons.forEach(function (b, i) { b.setAttribute("aria-checked", String(i + 1 === stage)); });
      if (count) count.textContent = "0" + stage + " / 03";
      setBars(0);
      if (reduce) {
        Object.keys(targets[stage]).forEach(function (key) { p[key] = targets[stage][key]; });
        draw();
      }
    }
    function frame(now) {
      var dt = Math.min(now - (last || now), 50);
      last = now;
      if (!paused) {
        elapsed += dt;
        if (elapsed >= DURATION) show(stage + 1);
      }
      setBars(Math.min(elapsed / DURATION, 1));
      var k = 1 - Math.pow(1 - 0.07, dt / 16.67);
      var target = targets[stage];
      Object.keys(target).forEach(function (key) { p[key] += (target[key] - p[key]) * k; });
      time += dt / 1000;
      for (var i = pulses.length - 1; i >= 0; i--) {
        pulses[i].t += dt / 1500;
        if (pulses[i].t >= 1) pulses.splice(i, 1);
      }
      draw();
      raf = requestAnimationFrame(frame);
    }

    buttons.forEach(function (b, i) {
      b.addEventListener("click", function () { show(i + 1); });
    });
    canvas.addEventListener("pointermove", function (event) {
      if (reduce) return;
      var rect = canvas.getBoundingClientRect();
      pointer.x = event.clientX - rect.left;
      pointer.y = event.clientY - rect.top;
      pointer.on = true;
    });
    canvas.addEventListener("pointerleave", function () { pointer.on = false; });
    canvas.addEventListener("pointerdown", function (event) {
      if (reduce) return;
      var rect = canvas.getBoundingClientRect();
      if (pulses.length > 3) pulses.shift();
      pulses.push({ x: event.clientX - rect.left, y: event.clientY - rect.top, t: 0 });
    });
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });
    window.addEventListener("resize", function () { resize(); if (reduce) draw(); });

    function start() {
      if (started) return;
      started = true;
      root.classList.add("is-live");
      resize();
      if (reduce) { show(3); return; }
      show(1);
      raf = requestAnimationFrame(frame);
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { threshold: 0.2 });
      io.observe(root);
      // Some embedded contexts throttle IO callbacks ,  start regardless.
      setTimeout(start, 1200);
    } else start();
  }

  /* ---------- Mobile menu (design-system pages) ---------- */
  function initDsMenu() {
    var toggle = document.querySelector(".mv-menu-toggle");
    var menu = document.getElementById("mv-menu");
    if (!toggle || !menu) return;
    var open = false;
    var header = document.querySelector(".mv-header");
    function syncOffset() {
      // The panel sits directly under the header, whose height varies with the
      // announcement bar. Measure it rather than assuming a fixed value.
      var bottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 65;
      menu.style.setProperty("--mv-header-offset", bottom + "px");
    }
    function setOpen(next) {
      open = next;
      if (open) syncOffset();
      menu.classList.toggle("is-open", open);
      menu.setAttribute("aria-hidden", String(!open));
      document.body.classList.toggle("mv-menu-open", open);
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close navigation menu" : "Open navigation menu");
    }
    toggle.addEventListener("click", function () { setOpen(!open); });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { setOpen(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && open) { setOpen(false); toggle.focus(); }
    });
    // Close if the viewport grows back past the breakpoint.
    window.addEventListener("resize", function () {
      if (open && window.innerWidth > 900) setOpen(false);
      else if (open) syncOffset();
    });
    window.addEventListener("scroll", function () { if (open) syncOffset(); }, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDsMenu();
    initHeader();
    initReveal();
    initScrollEffects();
    initScrollWords();
    initLazyVideos();
    initCoolingSequence();
    initHomeGallery();
    initTestimonials();
    initDetailGalleries();
    initReviewCarousels();
    initComfortProfile();
    initHeatStages();
  });
})();
